var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3278 17.4927V15.8267C13.3278 14.9431 12.9767 14.0956 12.3519 13.4707C11.727 12.8458 10.8795 12.4948 9.99584 12.4948H4.99792C4.11423 12.4948 3.26674 12.8458 2.64188 13.4707C2.01702 14.0956 1.66597 14.9431 1.66597 15.8267V17.4927",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49688 9.16285C9.33706 9.16285 10.8288 7.67109 10.8288 5.83091C10.8288 3.99073 9.33706 2.49896 7.49688 2.49896C5.65669 2.49896 4.16493 3.99073 4.16493 5.83091C4.16493 7.67109 5.65669 9.16285 7.49688 9.16285Z",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3257 17.4927V15.8267C18.3251 15.0885 18.0794 14.3713 17.6271 13.7879C17.1748 13.2044 16.5416 12.7877 15.8267 12.6031",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3278 2.60725C14.0445 2.79076 14.6797 3.20759 15.1334 3.79202C15.587 4.37645 15.8333 5.09524 15.8333 5.83508C15.8333 6.57491 15.587 7.2937 15.1334 7.87813C14.6797 8.46256 14.0445 8.87939 13.3278 9.0629",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9917,
    height: 19.9917,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/Users2.71002b216a017c32600898f4b8b09d0e.svg";
export { ForwardRef as ReactComponent };